import { ListCustomFieldsRequest } from "../CustomFieldRecord";

/**
 * TanStack-Query key factory for custom-field reads. The hierarchy
 * `all` ⊃ `lists()` ⊃ `list(orgId, request)` lets a mutation invalidate at
 * the broadest level it affects: create/update/delete invalidate `lists()`,
 * refetching every per-org, per-request list in one call.
 */
export const customFieldQueryKeys = {
  all: ["customFields"] as const,
  lists: () => [...customFieldQueryKeys.all, "list"] as const,
  list: (orgId: string, request: ListCustomFieldsRequest) =>
    [...customFieldQueryKeys.lists(), orgId, request] as const,
};
